import zhCN from "./zh-CN.js";
import enUS from "./en-US.js";
import esES from "./es-ES.js";
import deDE from "./de-DE.js";
import itIT from "./it-IT.js";
import ptPT from "./pt-PT.js";
import ruRU from "./ru-RU.js";
import srRS from "./sr-RS.js";
export default {
  locale: process.env.VUE_APP_I18N_LOCALE,
  fallbackLocale: process.env.VUE_APP_I18N_LOCALE,
  messages: {
    "zh-CN": zhCN,
    "es-ES": esES,
    "de-DE": deDE,
    "it-IT": itIT,
    "pt-PT": ptPT,
    "ru-RU": ruRU,
    "sr-RS": srRS,
    "en-US": enUS
    // 'es-ES': esES
  }
};
